export const logEvent = (eventName, props) => {
  if (!window.plausible) return;
  if (props) {
    window.plausible(eventName, { props });
  } else {
    window.plausible(eventName);
  }
};
